export const ClientStatus = {
  ACTIVE: 'Active',
  PENDING: 'Pending',
  INACTIVE: 'Inactive',
};

export const errorCodesFromBackend = {
  duplicateClientEmail: 'FulfillmentDelegationDuplicateInvitation',
  generalFailure: 'FulfillmentDelegationInvitationFailed',
};
